import CircleLoader from 'react-spinners/CircleLoader';

export const Loading = ({ size = 50, color = '#ff7761' }) => (
  <div className="loading-container">
    <CircleLoader size={size} color={color} />
  </div>
);

export default Loading;
